import React from 'react';
import get from 'lodash/get';
import Link from '@material-ui/core/Link';

const stopPropagation = (e) => e.stopPropagation();

const UrlField = ({ record, source, displayField = 'name' }) => {
  if (record[source]) {
    const url = `/#/${source}/${get(record, [source, 'id'])}`;
    return (
      <Link onClick={stopPropagation} href={url}>
        {record[source][displayField]}
      </Link>
    );
  }
  return null;
};

UrlField.defaultProps = {
  addLabel: true,
};

export default UrlField;
